import {
  makeObservable, onBecomeObserved,
} from 'mobx';
import mapValues from 'lodash/mapValues';
import makeQuery from '../../api/makeQuery';
import BaseModel from '../../models/BaseModel';
import PostCollection from './PostCollection';

class User extends BaseModel {
  static INITIAL_FIELDS = {
    firstName: '',
    lastName: '',
    email: '',
    active: true,
    id: '',
  };
  posts = new PostCollection(this);

  constructor(initialInfo) {
    super(initialInfo);
    console.log("constructing User");
    makeObservable(this, {
      ...mapValues(this.constructor.INITIAL_FIELDS, () => true),
    });
    console.log('creating post disposer');
    this.disposePostsFetcher = onBecomeObserved(
      this.posts,
      'list',
      () => {
        console.log('refetching posts');
        this.posts.refetch();
      },
    );
  }

  merge(valuesObj) {
    super.merge(valuesObj);
    if (valuesObj) {
      if (valuesObj.posts) this.posts.mergePosts(valuesObj.posts);
    }
  }

  destroy() {
    this.disposePostsFetcher();
    this.posts.destroy();
  }

  async updateCurrentUser() {
    const response = await makeQuery('@getUser', {userId: this.id});
    this.merge(response);
  }
}
export default User;
